import React from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import FadeIn from 'react-fade-in';

import { CONTENT_PROPS } from '../shared/constants';

//#region //// COMPONENTS ///
import BannerItem from './components/BannerItem';
import WithErrorBoundary from '../../HOCs/WithErrorBoundary';
//#endregion

//#region ///// DUCKS /////
import * as hooks from './hooks';
import './styles.scss';
//#endregion

// install Swiper components
SwiperCore.use([Autoplay, Navigation, Pagination, Scrollbar, A11y]);

function Banner({
  autoplay = true,
  contentCollection = [],
  disableAnimation = false,
  getContentListHandler,
  isLoading,
  selectedContentHandler
}) {
  const autoplayOptions = autoplay ? {
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    }
  } : {};

  //#region //// HOOKS ////
  const { mounted } = hooks.useDidMount();
  //#endregion

  //TODO: divs de animaciones comentados por problemas en su posicionamiento relativo al componente.
  return (
    <section className="tbxBanner">
      <FadeIn>
        { !disableAnimation && <div className={`tbxBanner--fadeTop animatedtop ${mounted ? 'animate' : ''}`}></div> }
        <div className="tbxBanner__container">
          <Swiper
            { ...autoplayOptions }
            centeredSlides={true}
            className="tbxBanner__container-swiper"
            draggable={false}
            grabCursor={false}
            loop={true}
            navigation={contentCollection.length > 1}
            pagination={contentCollection.length > 1}
          >
          { !isLoading && contentCollection.map((content, idx) => {
            return (
              <SwiperSlide
                className="tbxBanner__container-swiper-slide"
                onClick={() => selectedContentHandler && selectedContentHandler(content)}
                key={`tbx-banner-item-${idx}`}
              >
                <BannerItem content={content} />
              </SwiperSlide>
            )
            })
          }
          </Swiper>
        </div>
        { !disableAnimation && <div className={`tbxBanner--fadeBottom animatedbottom ${mounted ? 'animate' : ''}`}></div> }
      </FadeIn>
    </section>
  );
};

Banner.propTypes = {
  autoplay: PropTypes.bool,
  contentCollection: PropTypes.arrayOf(PropTypes.shape(CONTENT_PROPS)),
  disableAnimation: PropTypes.bool,
  getContentListHandler: PropTypes.func,
  isLoading: PropTypes.bool,
  selectedContentHandler: PropTypes.func
};

export default WithErrorBoundary(React.memo(Banner));
